import styled from 'styled-components';

interface ProgressLineProps {
  status: number;
}

export const ProgressLine = styled.div<ProgressLineProps>`
  position: absolute;
  top: 31px;
  left: 1px;
  height: 8px;
  width: ${props =>
    props.status === 0
      ? '0%'
      : props.status === 1
      ? '15%'
      : props.status === 2
      ? '50%'
      : props.status === 3
      ? '90%'
      : '99.7%'};
  border-radius: 10px;
  background: ${props => props.theme.success};
`;

export const ProgressBar = styled.div`
  height: 10px;
  width: 100%;
  border-radius: 10px;
  border: 1px solid
    ${props =>
      props.theme.darkMode ? props.theme.interface2 : props.theme.interface4};
  background: ${props => props.theme.interface2};
`;

export const ProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Label = styled.p`
  position: absolute;
  top: -14px;
  font-size: 9px;
  color: ${props => props.theme.success};
`;
